<template>
    <select v-model="modelValue" :aria-invalid="hasError" :aria-describedby="errorId">
        <option v-if="placeholder" value="" disabled hidden>
            {{ $t(placeholder) }}
        </option>
        <slot />
    </select>
</template>

<script setup>
const modelValue = defineModel({
    type: [String, Number],
    default: ''
})

defineProps({
    placeholder: {
        type: String,
        default: 'Select an option'
    },
    hasError: {
        type: Boolean,
        default: false
    },
    errorId: {
        type: String,
        default: null
    }
})
</script>
